export class NotificationConst {

  public static TITLE_DEFAULT = 'Algo deu errado';
  public static TITLE_SUCCESS = 'Realizado com sucesso';
  public static TITLE_WARNING = 'Aviso!';
}
